import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import CVBuilder from './pages/CVBuilder';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/builder" element={<CVBuilder />} />
    </Routes>
  );
}

export default App;
